const specialCharRegex = /[~`!@#$%^&*()_+\-={}[\];:"'\\|<,>.?–’/]/g;

/**
 * escape all of the special characters with a backslash
 * Useful when building regex from the input
 */
const safelyEscapeSpecialCharacters = (input: string): string =>
  input.replace(specialCharRegex, '\\$&');

export default safelyEscapeSpecialCharacters;
